import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import Theme from "../../.themes/common/Theme";

const useStyles = makeStyles((theme: Theme) => ({
    carInfo: {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.h3.fontSize,
        lineHeight: theme.typography.h3.lineHeight,
        ...theme.carInfo,
    },
    headingWithImage: {
        textAlign: "center",
        [theme.breakpoints.up("md")]: {
            textAlign: "left",
        },
    },
    headingWithoutImage: {
        textAlign: "center",
    },
}));

export type CarInfoProps = {
    isCarModelProfile: boolean;
    carRegistrationNumber?: string;
    carModel?: string;
    carYear?: string | number;
    hasCarImage: boolean;
};

export const CarInfo: React.FC<CarInfoProps> = (props: CarInfoProps) => {
    const classes = useStyles();
    const alignmentClass = props.hasCarImage ? classes.headingWithImage : classes.headingWithoutImage;
    const hasCarYear = !!props.carYear;

    return (
        <Box className='welcome-box-labels'>
            {props.isCarModelProfile ? (
                <>
                    <Typography className={clsx(classes.carInfo, alignmentClass)}>{props.carModel}</Typography>
                    <Typography className={clsx(classes.carInfo, alignmentClass)}>{props.carYear}</Typography>
                </>
            ) : (
                <>
                    <Typography className={clsx(classes.carInfo, alignmentClass)}>
                        {hasCarYear ? `${props.carModel} (${props.carYear})` : props.carModel}
                    </Typography>
                    <Typography className={clsx(classes.carInfo, alignmentClass, "data-hj-suppress")}>
                        {props.carRegistrationNumber}
                    </Typography>
                </>
            )}
        </Box>
    );
};

export default CarInfo;
